import { clsx } from 'clsx';
export const classes = (...classNames) => clsx(classNames);
